<h4 class="font-weight-bold py-3 mb-4">Statistics</h4>

<div class="card mb-4">
  <h6 class="card-header">
    Currently Certified
  </h6>
  <div class="row no-gutters row-bordered">
    <div class="col-sm-12 p-4">

      <ngx-charts-pie-grid
        [view]="view"
        [scheme]="colorScheme"
        [results]="validCerts"
        [designatedTotal]="allUsers.length"
        (select)="onSelect($event)">
      </ngx-charts-pie-grid>

    </div>
  </div>

</div>


<div class="card mb-4">
  <h6 class="card-header">
    Expiring Certificates
  </h6>
  <div class="row no-gutters row-bordered">
    <div class="col-sm-12 p-4">

      <ngx-charts-line-chart
        [view]="view"
        [scheme]="colorScheme"
        [legend]="legend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxis]="xAxis"
        [yAxis]="yAxis"
        [xAxisLabel]="xAxisLabel"
        [yAxisLabel]="yAxisLabel"
        [timeline]="timeline"
        [results]="multi"
        (select)="onSelect($event)">
      </ngx-charts-line-chart>


    </div>
  </div>

</div>

<div class="card mb-4">
  <h6 class="card-header">
    Expiring Certificates
  </h6>
  <div class="row no-gutters row-bordered">
    <div class="col-sm-12 p-4">

<!--      <table class="table table-striped">-->
<!--        <thead>-->
<!--        <tr>-->
<!--          <th>Certificate</th>-->
<!--          <th>Amount</th>-->
<!--        </tr>-->
<!--        </thead>-->
<!--        <tbody>-->
<!--        <tr *ngFor="let cg of soonExpiringCertificates">-->
<!--          <td>{{cg.name}}</td>-->
<!--          <td>-->
<!--            {{cg.certificates.length}}-->
<!--          </td>-->
<!--        </tr>-->
<!--        </tbody>-->
<!--      </table>-->
      <ol class="breadcrumb">
        <li class="breadcrumb-item" *ngFor="let breadcrumb of drillingBreadcrumb(); let i = index"><a href="javascript:void(0)" (click)="undoDrilling()">{{breadcrumb.value}}</a></li>
<!--        <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>-->
<!--        <li class="breadcrumb-item active">Library</li>-->
      </ol>
<!--      <button type="button" class="btn btn-primary btn-sm" (click)="undoDrilling()" *ngIf="drillingHasBeenDone()">Back</button>-->
      <p></p>
      <table class="table table-striped">
        <thead>
        <tr>
          <th *ngFor="let headerLabel of summary.headers">{{headerLabel}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let entry of summary.values" style="cursor: pointer;">
          <td *ngFor="let value of entry" (click)="drillIt(entry)">{{value}}</td>
        </tr>
        </tbody>
      </table>

    </div>
  </div>

</div>

<!--<div class="card mb-4">-->
<!--  <h6 class="card-header">-->
<!--    Currently Certified-->
<!--  </h6>-->
<!--  <div class="row no-gutters row-bordered">-->
<!--    <div class="col-sm-12 p-4">-->

<!--      <table class="table table-striped">-->
<!--        <thead>-->
<!--        <tr>-->
<!--          <th>Certificate</th>-->
<!--          <th>Amount</th>-->
<!--          <th>Percent</th>-->
<!--        </tr>-->
<!--        </thead>-->
<!--        <tbody>-->
<!--        <tr *ngFor="let cg of certificateGroups">-->
<!--          <td>{{cg.name}}</td>-->
<!--          <td>-->
<!--            {{cg.certificates.length}}-->
<!--          </td>-->
<!--          <td>-->
<!--            {{getPercentage(cg)}}-->
<!--          </td>-->
<!--        </tr>-->
<!--        </tbody>-->
<!--      </table>-->

<!--    </div>-->
<!--  </div>-->

<!--</div>-->






<div style="height: 300px">
<!--  <ngx-charts-pie-chart-->
<!--    [results]="data"-->
<!--    [legend]="true"-->
<!--    [explodeSlices]="true"-->
<!--    [labels]="true"-->
<!--    [scheme]="'vivid'">-->
<!--  </ngx-charts-pie-chart>-->


</div>
